import React from 'react';

const OrganisationLogo = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Organisation Logo</h1>
    </div>
  );
};

export default OrganisationLogo; 